<template>
    <Paper class="barcode-merge">
        <m-table
            ref="RegistrationTable"
            :pageTotal="pageTotal"
            :tableData="listData"
            :config="tableConfig"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @search="search"
            @onSearchDataChange="onSearchDataChange"
            @btn-event="goDetail"
            @cascadeChange="cascadeChange">
            <template v-slot:page-module-btn>
                <div class="btnList">
                    <el-button size="mini" type="primary" icon="el-icon-plus" @click="addData">新增</el-button>
                </div>
            </template>
        </m-table>
        <m-dialog ref="mFrom" :config="fromConfig" @submit="submit" @changeOrClear="changeOrClear" @close="close"></m-dialog>
    </Paper>
</template>

<script>
import Paper from '@/components/core/paper/Paper';
import mTable from '@/modules/sn/components/IdentityComponentCopy/Main';
import { sceneDomainList, addSceneDomainSave, updateSceneDomainSave, getSourceSysList } from '../../../api/systemManagementApi';
import { dictWithUrl } from '../../../components/basicDataDialog/api.js';
import { tableConfig } from './tableConfig.js';
import { fromConfig } from './fromConfig';
import mDialog from '@/modules/sn/components/formRequired/mDialog';
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
export default {
    name: 'domainName',
    components: { Paper, mTable, mDialog },
    data() {
        return {
            fromConfig,
            searchData: {},
            pageTotal: 0, // 总条数
            listData: [], // 列表数据
            tableConfig, // 表格配置
            stateDictList: {} // 可用状态字典
        };
    },
    created() {
    },
    mounted () {
        this.search(this.searchData);
        this.dicDomain();
    },
    unmounted() {
        this.$refs.mFrom.open();
    },
    computed: {
        ...mapGetters(['currentTenant'])
    },
    methods: {
        onSearchDataChange(data) {
            this.searchData = data;
        },
        pageChange(pageNo) {
            this.tableConfig.page.pageNo = pageNo;
            this.search(this.searchData);
        },
        sizeChange(pageSize) {
            this.tableConfig.page.pageNo = 1;
            this.tableConfig.page.pageSize = pageSize;
            this.search(this.searchData);
        },
        // 查询
        search(data) {
            this.getData(data);
        },
        getData(data) {
            const params = cloneDeep(data);
             Object.keys(params).forEach(item => {
                if (!params[item]) {
                    delete params[item];
                }
            });
            params.tenantCode = this.currentTenant.tenantCode;
            params.pageSize = this.tableConfig.page.pageSize;
            params.pageNo = this.tableConfig.page.pageNo;
            sceneDomainList(params).then((res) => {
                if (res.code + '' === '0' && res.data) {
                    this.pageTotal = res.data.totalCount;
                    this.listData = res.data.list.map(item => {
                        return {
                            ...item,
                            enableFlagName: item.enableFlag === 'Y' ? '启用' : '禁用'
                        };
                    });
                }
            });
        },
        goDetail(row, inte) {
            this.fromConfig.dialogAttr.title = '修改';
            const rowClone = cloneDeep(row);
            this.$refs.mFrom.open(rowClone);
            const params = {
                domainName: row.domainName
            };
            this.sourceSysEnable(params, this.fromConfig.fromComponent.component, 'prop');
        },
        addData() {
            this.fromConfig.dialogAttr.title = '新增';
            this.$refs.mFrom.open();
        },
        // 新增修改提交事件
        submit(val) {
            const params = {
                ...val
            };
            if (val.id) {
                // 修改
                updateSceneDomainSave(params).then(res => {
                    if (res.code + '' === '0') {
                        this.search(this.searchData);
                        this.$message.success('修改成功');
                    }
                });
            } else {
                // 新增
                params.tenantCode = this.currentTenant.tenantCode;
                addSceneDomainSave(params).then((res) => {
                    if (res.code + '' === '0') {
                        this.search(this.searchData);
                        this.$message.success('新增成功');
                    }
                });
            }
        },
        // 查询，选中领域触发
        cascadeChange(key, item) {
             if (item.value === 'domainName') {
                if (!key) {
                    // 清空来源系统选项
                    this.tableConfig.searchList.searchTxt.forEach(item => {
                        if (item.value === 'sourceSys') {
                            item.options = [];
                        }
                    });
                    return;
                }
                const params = {
                    domainName: key
                };
             this.sourceSysEnable(params, this.tableConfig.searchList.searchTxt, 'value');
            }
        },
        // 获取领域数据字典
        async dicDomain() {
         const options = await dictWithUrl('SCENE_DOMAIN');
         if (options.code + '' === '0') {
             this.fromConfig.fromComponent.component.forEach(item => {
             if (item.prop === 'domainName') {
                 item.options = this.dicEnable(options.data, 'SCENE_DOMAIN');
             }
         });
         this.tableConfig.searchList.searchTxt.forEach(item => {
             if (item.value === 'domainName') {
                item.options = this.dicEnable(options.data, 'SCENE_DOMAIN');
             }
         });
         }
        },
        // 对数据字典进行格式处理
        dicEnable(options, key) {
            if (options[key]) {
                return options[key].map(item => {
                    return {
                        label: item.name,
                        value: item.code
                    };
                });
            }
        },
        // 新增or修改，选中领域触发
        changeOrClear(key, item) {
            if (item.prop === 'domainName') {
                if (!key) {
                    // 清空来源系统选项
                    this.fromConfig.fromComponent.component.forEach(item => {
                        if (item.prop === 'sourceSys') {
                            item.options = [];
                        }
                    });
                    return;
                }
                const params = {
                    domainName: key
                };
            this.sourceSysEnable(params, this.fromConfig.fromComponent.component, 'prop');
            }
        },
        // 根据选中领域请求来源系统数据
        sourceSysEnable(params, config, key) {
            getSourceSysList(params).then(res => {
                if (res.code + '' === '0' && res.data) {
                config.forEach(item => {
                    if (item[key] === 'sourceSys') {
                        item.options = res.data.map(item => {
                            return {
                                label: item,
                                value: item
                            };
                        });
                    }
                });
                }
            });
        },
        // 弹窗隐藏清空来源系统选项
        close() {
            this.fromConfig.fromComponent.component.forEach(item => {
                if (item.prop === 'sourceSys') {
                    item.options = [];
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.barcode-merge {
    /deep/ .el-table {
        height: calc(100vh - 200px) !important;
    }
}
</style>
